export enum CategoryType {
  CARD = "card",
  COUNTER = "counter"
}

export interface Category {
  id: string;
  categoryType: CategoryType;
  title?: string;
  rowCardContainerAnnexe?: {
    id: string;
    title: string;
    showLength: boolean;
  };
  forcePortrait?: boolean;
  displaySingleCard?: boolean;
  actions?: {
    zoomable?: boolean;
    rotable?: boolean;
    attachments?: boolean;
    toggleSide?: boolean;
    shufflable?: boolean;
    tokens?: boolean;
  };
  displayFrontAsDefaultSide?: boolean; // if true, click show card focus
  removeAllTokenWhenDragIn?: boolean;
  fillSpace?: boolean;
  hover?: boolean;
}

export interface BoardGameSettings {
  boards: {
    id: string;
    players: string[];
    rows: {
      id: string;
      categories: Category[];
    }[];
  }[];
}
